import {
  type ForwardRefRenderFunction,
  forwardRef,
  createRef,
  useState,
  MouseEvent,
  useEffect,
} from "react";
import classNames from "classnames";
import { type InputBoxProps } from "./interfaces";
import styles from "./style.module.scss";
import Icon from "../Icon";
import { SearchOutline, Clear } from "@webnovel/chereads-icons";
import _throttle from "lodash/throttle";

const InternalInputBox: ForwardRefRenderFunction<HTMLElement, InputBoxProps> = (
  {
    size,
    defaultValue = "",
    className = "",
    innerClassName = "",
    children = null,
    onSearchChange,
    ...otherProps
  },
  ref
) => {
  const inputBoxRef = (ref as any) || createRef<HTMLElement>();
  // class
  const classNameRender = classNames(styles.inputBox, {
    _sm: size === "sm",
    _md: size === "md",
    _lg: size === "lg",
  });
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const currKeyword = event.target.value; // 当前输入框的value
    // console.log('currKeyword', currKeyword)
    onSearchChange?.(currKeyword);
  };

  useEffect(() => {
    inputBoxRef.current.value = defaultValue;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultValue]);

  useEffect(() => {
    const inputElement = inputBoxRef.current;
    window.onscroll = _throttle(() => {
      if (!inputElement.value) {
        inputElement.blur();
      }
    }, 500);
    return () => {
      window.onscroll = null;
    };
  }, [inputBoxRef]);

  const handleClear = () => {
    inputBoxRef.current.value = "";
    inputBoxRef.current.focus();
    onSearchChange?.("");
  };

  // @ts-ignore
  // @ts-ignore
  return (
    <div
      className={`${className} ${classNameRender} pr bsbb`}
      id="j_search_group"
    >
      <label
        className={`${styles.search_label} ${classNameRender} pa l0 t0 zi1 c_000`}
        htmlFor="search"
      >
        <Icon Svg={SearchOutline} className="pa_auto w100% h100%" />
      </label>
      <input
        id={"search"}
        key="input1"
        ref={inputBoxRef}
        className={`${styles.search_input} ${innerClassName} ${classNameRender} _with_clear w100% bsbb c_l fw500 pt4 pb4 db`}
        type="search"
        autoComplete="off"
        defaultValue={defaultValue}
        {...otherProps}
        onChange={(e: React.ChangeEvent<HTMLInputElement>): void =>
          handleChange(e)
        }
      />

      <label
        className={`pa ${styles.close} ${classNameRender} ${
          defaultValue ? "" : "dn"
        } clear_label r0 t50% c_l `}
        onClick={handleClear}
        title="close"
      >
        <Icon Svg={Clear} className="pa_auto w100% h100%" />
      </label>
    </div>
  );
};

const InputBox = forwardRef<HTMLElement, InputBoxProps>(InternalInputBox);

export default InputBox;
